/**
 * Design tokens: the one place to restyle the demo.
 * Sampled from the new passiolife.com homepage design (navy + cream, lime CTA, violet accent).
 * Mantine palettes and CSS variables are both generated from these values.
 */
export const palette = {
  ink: "#0B1320",
  inkRaised: "#141C2F",
  inkBorder: "#1F2835",
  inkMuted: "#9AA2B3",
  cream: "#F5F4EF",
  sand: "#ECE9E1",
  paper: "#FFFFFF",
  text: "#0B1320",
  textMuted: "#575E6B",
  lime: "#8EE43B",
  violet: "#8C6CFB",
  green: "#3F8F1F",
  amber: "#E8A33D",
  red: "#E5484D",
  protein: "#8C6CFB",
  carbs: "#8EE43B",
  fat: "#E8A33D",
} as const;

/** 10-shade scales for Mantine (index 5 = brand value). */
export const scales = {
  lime: ["#f4fde9", "#e6f9d0", "#cdf2a3", "#b2eb72", "#9be64f", "#8EE43B", "#7acb2c", "#62a522", "#4a7f19", "#33590f"],
  violet: ["#f2efff", "#e2dbff", "#c6b8fe", "#a993fd", "#9779fb", "#8C6CFB", "#7552e6", "#5e3fc4", "#48309a", "#332270"],
  ink: ["#eceef2", "#cfd3dc", "#9AA2B3", "#6b7487", "#47505B", "#2a3242", "#1F2835", "#141C2F", "#0B1320", "#060b14"],
  sand: ["#fbfaf7", "#F5F4EF", "#ECE9E1", "#ddd8cc", "#cec6b6", "#b3a993", "#968b73", "#786f5b", "#5b5444", "#3e392e"],
} as const satisfies Record<string, readonly string[]>;

export const fonts = {
  body: "Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  heading: "Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
} as const;

export const radius = { sm: "6px", md: "10px", lg: "14px", xl: "20px" } as const;

/** JSON viewer colors (on the dark code surface). */
export const codeColors = {
  background: palette.ink,
  key: "#C6B8FE",
  string: "#B2EB72",
  number: "#F5C26B",
  boolean: "#7FD1F5",
  null: "#9AA2B3",
  punctuation: "#6b7487",
} as const;
